export const typesForBulk = [{ name: 'NON-INSTANT TRANSFER', key: 'NON_INSTANT' }];
export type TabsType = 0 | 1 | 2 | 3 | false;
export const tabsOptions = [
  { label: 'Between Own Accounts' },
  { label: 'To First Atlantic Bank' },
  { label: 'To Another Bank' },
  { label: 'Bulk Transfer' },
];

export const tabsFieldNames = ['toSelf', 'local', 'otherbank'] as const;
